import { ApolloLink } from '@apollo/client'

import { getAccessKey } from '@/lib/accessKey'

type Context = {
  headers: Record<string, unknown>
}

export const authLink = new ApolloLink((operation, forward) => {
  const accessKey = getAccessKey()
  operation.setContext(({ headers }: Context) => ({
    headers: {
      'Ocp-Apim-Subscription-Key': accessKey,
      ...headers,
    },
  }))
  return forward(operation)
})
